module.exports = __webpack_public_path__ + "img/landing_services.4be06790.png";